import { TanStackDevtools } from "@tanstack/react-devtools";
import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtoolsPanel } from "@tanstack/react-router-devtools";
import { FeatureFlagsInitializer } from "../components/FeatureFlagsInitializer";
import { IOSIntegrationInitializer } from "../components/IOSIntegrationInitializer";
import { PrepareInitializer } from "../components/PrepareInitializer";
import { SessionInitializer } from "../components/SessionInitializer";
import { URLParamsInitializer } from "../components/URLParamsInitializer";

import { Toaster } from "../components/ui/sonner";
import TanStackQueryDevtools from "../integrations/tanstack-query/devtools";
import RampsStoreDevtools from "../lib/ramps-store-devtools";

export interface MyRouterContext {
	queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
	component: () => (
		<>
			<FeatureFlagsInitializer />
			<URLParamsInitializer />
			<PrepareInitializer />
			<SessionInitializer />
			<IOSIntegrationInitializer />
			<Toaster />
			<Outlet />
			<TanStackDevtools
				config={{
					position: "bottom-left",
				}}
				plugins={[
					{
						name: "Tanstack Router",
						render: <TanStackRouterDevtoolsPanel />,
					},
					RampsStoreDevtools,
					TanStackQueryDevtools,
				]}
			/>
		</>
	),
});
